import { useQuery } from "@tanstack/react-query";
import { useStore } from "@/lib/store";
import { shopify } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Link } from "react-router-dom";
import { t } from "@/lib/i18n";

export default function Wishlist() {
  const { wishlist } = useStore();
  const { data: products = [] } = useQuery({
    queryKey: ["all-products-for-wishlist"],
    queryFn: () => shopify.products("NO"),
  });

  const items = products.filter(p => wishlist.includes(p.handle));

  return (
    <div className="pt-24 md:pt-32 px-5 md:px-12 pb-24 md:pb-32">
      <p className="text-eyebrow mb-3">{t.wishlist.eyebrow}</p>
      <h1 className="font-serif-editorial text-5xl md:text-8xl mb-10 md:mb-12">{t.wishlist.title}</h1>

      {items.length === 0 ? (
        <div className="py-20 md:py-24 text-center" data-testid="wishlist-empty">
          <p className="font-serif-editorial text-2xl md:text-3xl mb-4">{t.wishlist.empty}</p>
          <Link to="/shop" className="text-eyebrow link-underline">{t.wishlist.emptyCta}</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-10" data-testid="wishlist-grid">
          {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
